import { Component } from '@ecs/Component';
import { Position } from '@/types';

export class PlayerInput implements Component {
  readonly type = 'PlayerInput';

  constructor(
    public targetPosition: Position | null = null,
    public targetEntity: number | null = null, // focus-fire target
    public pursueTarget: boolean = false // close to weapon range of targetEntity (attack order)
  ) {}
}
